import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Corrected import location for useNavigate
import { Container, Typography, List, ListItem, ListItemText, Button } from '@mui/material';

const OnboardingOptions = () => {
  const [points, setPoints] = useState(0);
  const [learnedWords, setLearnedWords] = useState([]);
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/learning-flow');
  };

  useEffect(() => {
    // Fetch learned words from local storage
    const storedWords = JSON.parse(localStorage.getItem('learnedWords')) || [];
    setLearnedWords(storedWords);

    // Calculate points based on the number of learned words
    const storedPoints = storedWords.length;
    setPoints(storedPoints);
  }, []);

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        {points} : نقــاطـــك
      </Typography>

      <Button variant="contained" color="primary" onClick={handleNext}>
        !تعلم 5 كلمات جديدة
      </Button>

      <Typography variant="h6" gutterBottom>
        :الكلمات التي تعلمتها
      </Typography>
      <List component="nav">
        {learnedWords.length > 0 ? (
          learnedWords.map((word, index) => (
            <ListItem key={index}>
              <ListItemText primary={word} />
            </ListItem>
          ))
        ) : (
          <Typography variant="body1" color="textSecondary">
            لم تتعلم أي كلمات حتى الآن.
          </Typography>
        )}
      </List>
    </Container>
  );
};

export default OnboardingOptions;
